import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFShopify from '@/components/UI/svg/river2/Icon/EFShopify';
import EFGeneratorSolar from '@/components/UI/svg/river2/Icon/EFGeneratorSolar';
import EFGeneratorFaster from '@/components/UI/svg/river2/Icon/EFGeneratorFaster';
import EFGeneratorIP68 from '@/components/UI/svg/river2/Icon/EFGeneratorIP68';
import EFGenerator10 from '@/components/UI/svg/river2/Icon/EFGenerator10';
import EFGeneratorEasily from '@/components/UI/svg/river2/Icon/EFGeneratorEasily';
import EFGeneratorSaving from '@/components/UI/svg/river2/Icon/EFGeneratorSaving';
import EFVideo from '@/components/UI/EFVideo';
import { SHOW_RIVER2_OPTIMIZATION } from '@/constants';

const ZA_IMG = {
    H2: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711700818661/r2p_h1_768_za.jpg',
    H3: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711700755587/r2p_h2_768_za.jpg',
    H4: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711700765383/r2p_h3_768_za.jpg',
    H1: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711700773624/r2p_h4_768_za.jpg',
    H5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711700782127/r2p_h5_768_za.jpg',
};
const { EFPic } = createEFPic('');
export default function H() {
    const { useLang, useState, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('productriver2');
    const [showDialog, setShowDialog] = useState(false);

    const dialogList1: any = [
        {
            icon: <EFGeneratorSolar />,
            text: t('river2.details.sec8_list1_text1'),
        },
        {
            icon: <EFGeneratorFaster />,
            text: t('river2.details.sec8_list1_text2'),
        },
        {
            icon: <EFGeneratorIP68 />,
            text: t('river2.details.sec8_list1_text3'),
        },
        {
            icon: <EFGeneratorEasily />,
            text: t('river2.details.sec8_list1_text4'),
        },
        {
            icon: <EFGenerator10 />,
            text: t('river2.details.sec8_list1_text5'),
        },
        {
            icon: <EFGeneratorSaving />,
            text: t('river2.details.sec8_list1_text6'),
        },
    ];

    const dialogList2: any = [
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1752228471885/1.png'
                    : ['/media/river2/h5/river2_110w.webp', '/media/river2/h5/river2_110w.png'],
            text: t('river2.details.sec8_list2_text1'),
            link: {
                jp: 'https://jp.ecoflow.com/products/river-2-solar-generator-110w-solar-panel',
                mx: 'https://mx.ecoflow.com/products/generator-river-2-110w-solar-panel',
                local: `https://${locale}.ecoflow.com/products/river-2-110w-portable-solar-panel${locale === 'ca' ? '?variant=42680870994074' : ''}`,
            },
        },
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1752228471489/2.png'
                    : ['/media/river2/h5/river2max_160w.webp', '/media/river2/h5/river2max_160w.png'],
            text: t('river2.details.sec8_list2_text2'),
            link: {
                jp: 'https://jp.ecoflow.com/products/river-2-max-solar-generator-160w-solar-panel',
                cn: 'https://item.jd.com/10061057781058.html#crumb-wrap',
                mx: 'https://mx.ecoflow.com/products/generator-ecoflow-river-2-max-160w-solar-panel',
                ph: 'https://ph.ecoflow.com/products/ecoflow-river-2-max-160w-solar-panel',
                local: `https://${locale}.ecoflow.com/products/river-2-max-160w-portable-solar-panel${locale === 'ca' ? '?variant=42680871026842' : ''}`,
            },
        },
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1752228471683/3.png'
                    : ['/media/river2/h5/river2pro_220w.webp', '/media/river2/h5/river2pro_220w.png'],
            text: t('river2.details.sec8_list2_text3'),
            link: {
                jp: 'https://jp.ecoflow.com/products/river-2-pro-solar-generator-220w-solar-panel',
                cn: 'https://item.jd.com/10061057574837.html#crumb-wrap',
                mx: 'https://mx.ecoflow.com/products/generator-delta-2-220w-portable-solar-panel',
                ph: 'https://ph.ecoflow.com/products/ecoflow-river-2-pro-220w-solar-panel',
                local: `https://${locale}.ecoflow.com/products/river-2-pro-220w-portable-solar-panel${locale === 'ca' ? '?variant=42680871125146' : ''}`,
            },
        },
    ];

    if (locale === 'cn') {
        dialogList2.shift();
    }

    const onSolarPanel = (list: any) => {
        window.open(list?.link[locale] || list?.link?.local, '_blank');
    };

    let lists = [];
    if (SHOW_RIVER2_OPTIMIZATION.includes(locale)) {
        lists = [
            {
                text: locale === 'za' ? '' : t('river2.details.sec8_Solar'),
                img:
                    locale === 'za'
                        ? ZA_IMG.H1
                        : ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale)
                        ? ['/media/river2/h5/H2_eu.jpg', '/media/river2/h5/H2_eu.jpg']
                        : ['/media/river2/h5/8_4.webp', '/media/river2/h5/8_4.png'],
                color: '#000',
            },
            { text: t('river2.details.sec8_AC'), img: locale === 'za' ? ZA_IMG.H2 : ['/media/river2/h5/8_1.webp', '/media/river2/h5/8_1.png'], color: '#000' },
            { text: t('river2.details.sec8_Car'), img: locale === 'za' ? ZA_IMG.H3 : ['/media/river2/h5/8_2.webp', '/media/river2/h5/8_2.png'], color: '#000' },
            {
                text: t('river2.details.sec8_Typc'),
                img:
                    locale === 'za'
                        ? ZA_IMG.H4
                        : ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale)
                        ? ['/media/river2/h5/H1_eu.jpg', '/media/river2/h5/H1_eu.jpg']
                        : ['/media/river2/h5/8_3.webp', '/media/river2/h5/8_3.png'],
                color: '#000',
            },
            {
                text: t('river2.details.sec8_Generator_c'),
                img: locale === 'za' ? ZA_IMG.H5 : ['/media/river2/h5/H4_generator.webp', '/media/river2/h5/H4_generator.png'],
                color: '#000',
            },
        ];
    } else {
        lists = [
            {
                text: t('river2.details.sec8_Solar'),
                img:
                    locale === 'ph'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1751079780374/6-3-m.jpg'
                        : ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)
                        ? ['/media/river2/h5/H2_eu.jpg', '/media/river2/h5/H2_eu.jpg']
                        : ['/media/river2/h5/8_4.webp', '/media/river2/h5/8_4.png'],
                color: '#000',
            },
            {
                text: t('river2.details.sec8_AC'),
                img:
                    locale === 'ph'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1751079779758/6-2-m.jpg'
                        : ['/media/river2/h5/8_1.webp', '/media/river2/h5/8_1.png'],
                color: '#000',
            },
            {
                text: t('river2.details.sec8_Car'),
                img:
                    locale === 'ph'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1751079779584/6-1-m.jpg'
                        : ['/media/river2/h5/8_2.webp', '/media/river2/h5/8_2.png'],
                color: '#000',
            },
            {
                text: t('river2.details.sec8_Typc'),
                img:
                    locale === 'ph'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1751079780144/6-4-m.jpg'
                        : ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)
                        ? ['/media/river2/h5/H1_eu.jpg', '/media/river2/h5/H1_eu.jpg']
                        : ['/media/river2/h5/8_3.webp', '/media/river2/h5/8_3.png'],
                color: '#000',
            },
        ];
    }

    const [active, setActive] = useState(0);
    const [idx, setIdx] = useState(0);

    const onLeft = () => {
        if (active > 0) {
            setActive(active - 1);
        }
    };

    const onRight = () => {
        if (active < lists?.length - 1) {
            setActive(active + 1);
        }
    };

    let startX = 0;
    // 开始移动
    const onStart = (e: any) => {
        if (locale !== 'cn') {
            startX = e.targetTouches[0].clientX;
        }
    };

    //移动结束： 修正偏移状态
    const onEnd = (e: any) => {
        if (locale !== 'cn') {
            const moveX = e?.changedTouches[0]?.clientX;
            e.currentTarget.style.transition = 'left 0.3s ease';
            // 第一列且右滑
            if (moveX < startX && idx === 0) {
                e.currentTarget.style.left = `-1.28rem`;
                setIdx(1);
            }
            // 第二列且左滑
            if (moveX > startX && idx === 1) {
                e.currentTarget.style.left = `0`;
                setIdx(0);
            }
        }
    };

    const getOptimizationDesc = () => {
        if (SHOW_RIVER2_OPTIMIZATION.includes(locale)) {
            return {
                title: t('river2.details.sec8_optimize_title'),
                desc: t('river2.details.sec8_optimize_desc'),
            };
        }
        return {
            title: t('river2.details.sec8_title'),
            desc: t('river2.details.sec8_desc'),
        };
    };

    return (
        <div className={`river2_details_H_1 ${css.H_8}`}>
            <div className={`innerBox`}>
                <div className="textBox">
                    <p className="guide">{getOptimizationDesc().title}</p>
                    <p className="title">{t('river2.details.sec8_change')}</p>
                    <p className="desc">{getOptimizationDesc().desc}</p>
                </div>
                <div className="imgBoxAll">
                    <ul className={`imgLists swiper_${active}`}>
                        {lists?.map((list: any, k: number) => (
                            <li className={`imgList imgList-${k + 1}`} key={k}>
                                <div className="imgItemBox">
                                    {locale === 'ph' ? (
                                        <img src={list?.img} alt={list?.text} aria-label={list?.text} />
                                    ) : (
                                        <EFPic name={list?.img} alt={list?.text} aria-label={list?.text} />
                                    )}
                                    <p className="listText" style={{ color: list?.color }}>
                                        {list?.text}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="navigation">
                        <div className={`leftBtn arrowBtn ${active > 0 ? 'active' : ''}`} onClick={onLeft}></div>
                        <div className={`rightBtn arrowBtn ${active < lists.length - 1 ? 'active' : ''}`} onClick={onRight}></div>
                    </div>
                </div>
                <div className="note">
                    {t.rich('river2.details.sec8_product_details', {
                        p1: (child: React.ReactNode) => <div className="title-p1">{child}</div>,
                        p2: (child: React.ReactNode) => <span className="title-p2">{child}</span>,
                    })}
                </div>
                <div
                    className={`generatorBox ${
                        ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn', 'br', 'mx', 'ph'].includes(locale) ? 'show' : 'hide'
                    }`}
                >
                    <div className="generator" onClick={() => setShowDialog(true)}>
                        <div className="text">{t('river2.details.sec8_generator')}</div>
                        <div className="plusIcon">+</div>
                    </div>
                </div>
            </div>
            <div className={`generatorModal ${showDialog ? 'show' : 'hide'}`}>
                <div className="wrapper">
                    <div className="content">
                        <div className="close" onClick={() => setShowDialog(false)}>
                            &times;
                        </div>
                        <div className="bannerImg">
                            <EFVideo
                                width={'100%'}
                                height={'100%'}
                                sources={[
                                    `/video/river2/details/generator_${
                                        locale === 'ph'
                                            ? 'eu '
                                            : ['us', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn'].includes(locale)
                                            ? locale
                                            : locale === 'sa'
                                            ? 'uk'
                                            : 'us'
                                    }.webm`,
                                    `/video/river2/details/generator_${
                                        locale === 'ph'
                                            ? 'eu'
                                            : ['us', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn'].includes(locale)
                                            ? locale
                                            : locale === 'sa'
                                            ? 'uk'
                                            : 'us'
                                    }.mp4`,
                                ]}
                            />
                        </div>
                        <div className="innerWrapper">
                            <p className="textTop">{t('river2.details.sec8_generator_text1')}</p>
                            <ul className="iconLists">
                                {dialogList1?.map((list: any, k: number) => (
                                    <li className="list1Box" key={`list1_${k}`}>
                                        <div className="list1Icon">{list?.icon}</div>
                                        <div className="list1Text">{list?.text}</div>
                                    </li>
                                ))}
                            </ul>
                            <p className="textBottom">{t('river2.details.sec8_generator_text2')}</p>
                            <div className="productsContainer">
                                <ul className="productLists" onTouchStart={onStart} onTouchEnd={onEnd}>
                                    {dialogList2?.map((list: any, k: number) => (
                                        <li className="list2Box" key={`list2_${k}`}>
                                            <div className="list2Img">
                                                {locale === 'ph' ? (
                                                    <img src={list.img} alt={list?.text} className="fullImgs" />
                                                ) : (
                                                    <EFPic name={list.img} alt={list?.text} className="fullImgs" />
                                                )}
                                            </div>
                                            <div className="list2Text">{list?.text}</div>
                                            <div className="list2Btn" onClick={() => onSolarPanel(list)}>
                                                <div className="btnIcon">
                                                    <EFShopify width={'100%'} height={'100%'} />
                                                </div>
                                                <div className="btnText">{t('river2.details.sec8_store')}</div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <p className="noteText">{t('river2.details.sec8_generator_text3')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx global>
                {`
                    .product_naver {
                        display: ${showDialog ? 'none' : 'block'};
                    }
                    .ecoflow-mobile {
                        .headerh5 {
                            display: ${showDialog ? 'none' : 'block'};
                        }
                    }
                    .ant-back-top {
                        display: ${showDialog ? 'none' : 'block'};
                    }
                `}
            </style>
        </div>
    );
}
